import { appButtonBackground, grayText, appBorderColor, chatHistoryBGColor } from 'globals/colors';
import { transitionDuration, transitionFunction } from 'globals/styles';

export default {
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '10px 0px',
    backgroundColor: chatHistoryBGColor,
  },
  endChatBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: appButtonBackground,
    color: grayText,
    fontSize: 10,
    fontWeight: 500,
    border: `1px solid ${appBorderColor}`,
    textAlign: 'center',
    cursor: 'pointer',
    transition: `all ${transitionDuration} ${transitionFunction}`,
    WebkitAppearance: 'none',
    flex: '0 1 auto',
    padding: '3px 5px',
    borderRadius: '10px',
    height: '20px',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',

    ':hover': {
      color: 'rgb(112, 112, 112)',
      backgroundColor: 'rgb(241, 241, 241)',
    },
    ':active': {
      color: 'rgb(112, 112, 112)',
      backgroundColor: 'rgb(241, 241, 241)',
    },
  },
};
